import styled, { spacing } from "@rentiohq/web-theme";

export const Wrap = styled.div`
  color: ${({ theme }) => theme.colors.neutral90};
  font-size: 15px;
  line-height: 1.6;
`;

export const Paragraph = styled.p`
  margin: 0 0 ${spacing("base")};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const List = styled.ul`
  margin: 0 0 ${spacing("base")};
  padding-left: ${spacing("loose")};

  &:last-child {
    margin-bottom: 0;
  }

  li + li {
    margin-top: ${spacing("extraTight")};
  }
`;
